var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpressJsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7832 1.60057H39.1032C38.2624 1.60057 37.4704 1.99257 36.9592 2.65977L29.9992 11.7614L23.0392 2.65977C22.5296 1.99257 21.7368 1.60057 20.8968 1.60057H20.2168L28.9936 13.0774L20.0288 24.8006H20.7088C21.5496 24.8006 22.3416 24.4086 22.852 23.7414L30 14.3942L37.148 23.7414C37.6584 24.4086 38.4504 24.8006 39.2912 24.8006H39.9712L31.0064 13.0774L39.7832 1.60057ZM17.0312 20.1942C14.988 23.299 10.9656 24.8902 7.12 23.487C3.7368 22.2526 1.6 18.8894 1.6 15.2878V14.4006H11.2H20V11.0934C20 5.88937 16.1456 1.33337 10.964 0.846173C5.0184 0.286973 0 4.96857 0 10.8006V15.259C0 19.5558 2.572 23.5502 6.6152 25.0054C11.8976 26.9062 17.4536 24.0694 19.332 19.2006H18.8216C18.0928 19.2006 17.4312 19.5854 17.0312 20.1942ZM1.6 10.8006C1.6 6.16857 5.368 2.40057 10 2.40057C14.632 2.40057 18.4 6.16857 18.4 10.8006V12.8006H1.6V10.8006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressJsLogo);
export default __webpack_public_path__ + "static/media/express-js-logo.9607cf2ae05e9cfda1f2fcfe98bdac8b.svg";
export { ForwardRef as ReactComponent };